import { render, staticRenderFns } from "./SetMarker.vue?vue&type=template&id=2663b96a&scoped=true&"
import script from "./SetMarker.vue?vue&type=script&lang=js&"
export * from "./SetMarker.vue?vue&type=script&lang=js&"
import style0 from "./SetMarker.vue?vue&type=style&index=0&id=2663b96a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2663b96a",
  null
  
)

export default component.exports